module.exports = __webpack_public_path__ + "img/auto-reply.5b6bf045.svg";